<div class="supplementary-equipment-details">
    <div class="options-list">
        <div class="form-box">
            <sc-padding>
                <sc-flex vertical stretchContent>
                    <ng-container *ngFor="let se of supplementaryEquipment; let i = index">
                        <sc-content-spacer vertical *ngIf="i > 0"></sc-content-spacer>
                        <div class="form-checkbox">
                            <div class="checkbox-label">
                                <mat-checkbox [disabled]="true" [ngModel]="true">
                                  <sc-dictionary-label [dictionaryKey]="se.dictionaryKey"></sc-dictionary-label>
                                </mat-checkbox>
                            </div>
                            <mat-form-field class="checkbox-value mat-form-field-readonly" *ngIf="se.parameter1Value" appearance="fill">
                              <mat-label>
                                <sc-dictionary-label [dictionaryKey]="se.parameter1DictionaryKey"></sc-dictionary-label>
                              </mat-label>
                                <input matInput [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: true}"
                                    [readonly]="true">
                            </mat-form-field>
                        </div>
                    </ng-container>
                </sc-flex>
            </sc-padding>
        </div>
    </div>
</div>
